module.exports = __webpack_public_path__ + "img/no_logo_white@2x.7cc5cc4c.png";